const EvaluatorObject = {
  id: undefined,
  code: '',
  scode: '',
  name: '',
  profesionalId: ''
};

export default EvaluatorObject;
